import { render, staticRenderFns } from "./ResumeClassificationModal.vue?vue&type=template&id=1b43f061&scoped=true"
import script from "./ResumeClassificationModal.vue?vue&type=script&lang=js"
export * from "./ResumeClassificationModal.vue?vue&type=script&lang=js"
import style0 from "./ResumeClassificationModal.vue?vue&type=style&index=0&id=1b43f061&prod&lang=scss&scoped=true"
import style1 from "./ResumeClassificationModal.vue?vue&type=style&index=1&id=1b43f061&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43f061",
  null
  
)

export default component.exports